import ExpandableSection from "../component/_expandableSection";

new ExpandableSection('.js-footer-column', '.js-footer-title-wrapper', '.js-footer-list', '.js-title-chevron', true, true, false, false );

